module.exports = __webpack_public_path__ + "img/caretLeft.cdeb6a88.svg";